// 从 user-poster-editor/src/collapse/views/watermarkCollapse/components/confirm/index.tsx 搬迁
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Checkbox, Modal } from '@meitu/saas-ui';
import { useLocaleStore } from '@/i18n';

const { confirm } = Modal;

export const LOCAL_WATERMARK_CONFIRM = 'local-watermark-confirm';

export const useWatermarkConfirm = () => {
    // const [check, setCheck] = useState<boolean>(false);
    const { $t } = useLocaleStore();
    let check = false;
    const watermarkConfirm = (resolve: Function, reject: Function) => {
        const content = () => {
            return (
                <div className="watermark-confirm-content">
                    <div>{$t((v) => v.collapse.watermarkCollapse.confirmContent)}</div>
                    <Checkbox
                        onChange={(e: CheckboxChangeEvent) => {
                            // setCheck(e.target.checked);
                            check = e.target.checked;
                        }}
                    >
                        {$t((v) => v.collapse.watermarkCollapse.confirmNoMind)}
                    </Checkbox>
                </div>
            );
        };
        return confirm({
            title: $t((v) => v.collapse.watermarkCollapse.confirmTitle),
            content: content(),
            okText: $t((v) => v.collapse.watermarkCollapse.confirmOk),
            cancelText: $t((v) => v.collapse.watermarkCollapse.confirmCancel),
            onOk() {
                check && localStorage.setItem(LOCAL_WATERMARK_CONFIRM, String(check));
                resolve();
            },
            onCancel() {
                reject();
            },
        });
    };
    return {
        watermarkConfirm,
    };
};
